import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register all GSAP plugins once, here.
gsap.registerPlugin(ScrollTrigger);

export { gsap, ScrollTrigger };
